import React from 'react'

import { Container, Row, Col, Image } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import WhyKITItem from './WhyKITItem'

const reasonsWhyKIT = [
  'KIT Cambodia didirikan sejak tahun 2014 oleh Mr. Takeshi Izuka, adalah tempat terbaik untuk mengembangkan potensi kamu. Kampus ini percaya pada pengembangan diri, dan fokus pada peningkatan keterampilan dan pengetahuan mahasiswanya.',
  'Terdapat berbagai beasiswa yang bisa kamu dapatkan, jumlahnya mulai dari 15.100 USD-31.500 USD untuk mendukung studimu nanti.',
  'Dengan jaringan kerja sama yang luas di beberapa perusahaan sponsor dari berbagai negara seperti Jepang, Hong Kong, Singapura, dan India, kesempatanmu untuk mendapatkan kerja semakin terjamin.',
  'Berdiri di kawasan Kirirom National Park, KIT Cambodia menyediakan berbagai fasilitas dengan kualitas internasional seperti layanan kesehatan dan keselamatan, transportasi gratis, asrama, dan akomodasi lainnya.',
  'KIT Cambodia menawarkan lingkungan belajar yang nyaman yang siap membantumu dalam proses pembelajaran.',
]

const WhyKIT = () => (
  <div id="why-kit" className="why-kit">
    <Container>
      <Row>
        <Col md="3">
          <Typography component="h2" variant="big" className="why-kit__title">
            Kenapa <br/> KIT Cambodia?
          </Typography>
          <Image
            src="/assets/img/kit-landing/why_kit/kehidupan-kampus-kit-cambodia-quipper-campus.jpg"
            className="img-responsive"
            alt="Kehidupan Kampus KIT Cambodia | Quipper Campus"
          />
        </Col>
        <Col
          md="9"
          className="why-kit__reasons"
        >
          {
            reasonsWhyKIT.map((reason, idx) => (
              <WhyKITItem content={reason} no={idx + 1} key={`reason-${idx}`} />
            ))
          }
        </Col>
      </Row>
    </Container>
  </div>
)

export default WhyKIT
